export default {
  "processing-request": " Processing request...",
  "action-take-minutes": "This action could take few minutes.",
  "check-process":
    " You can check the process anytime from the Background Requests section.",
  "apply-billable-items-bulk": " Apply Billable Items in Bulk",
  "apply-one-billable-item-bulk":
    "Apply One Billable Item in Bulk (Max. 10.000)",
  "define-item-and-amount": "Define the item and amount (income or expense)",
  "apply-multiple-billable-item-bulk":
    "Apply Multiple Billable Items in Bulk (With CSV)",
  "define-items-and-amounts":
    "Define multiple items and amounts (income or expense)",
  "download-csv-fill": "Download CSV to fill in",
  "same-income-expense": "Set Same Incomes & Expenses (Max. 10.000)",
  "set-identical-items": "Set identical values across all selected items",
  "define-agreed-income-expense": "Define Agreed Incomes & Expenses",
  "recalculate-invoices": " Recalculate Orders Invoices (Max. 5.000)",
  "recalculate-invoices-tariff":
    "Recalculate invoices according to current tariff",
  "recalculate-billing-amounts-selected":
    "Recalculate billing amounts for the selected items",
  "different-income-expense": "Set Different Incomes & Expenses (With CSV)",
  "set-different-items": "Set different values across all selected items",
  "download-billing-summaries": "Download Billing Summaries (Max. 10.000)",
  "download-income-expense-summaries": "Download Income or Expense Summaries",
  "choose-list-billing-summaries":
    "Choose from a list the Billing Summaries you need",
  income: "Income",
  expense: "Expense",
  amount: "Amount",
  billing_title: "Type of Billing Item",
  billing_name: "Name for Billing Item",
  billing_name_placeholder: "Describe briefly the concept",
  amount_placeholder: "0",
};
